import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { OfficeModalContainerComponent } from './modal-container/modal-container.component';
import { OfficeModalContainerModule } from './modal-container/modal-container.module';
import { OfficeModalComponent } from './modal.component';

@NgModule({
	declarations: [OfficeModalComponent],
	imports: [CommonModule, OfficeModalContainerModule],
	exports: [OfficeModalComponent, OfficeModalContainerComponent],
})
export class OfficeModalModule {}
